import { Component, OnInit } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  dashboard_details:any;

  constructor( private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    ) { }

  ngOnInit() {
    this.getDashboardDetails();
  }


  getDashboardDetails() {
    let url = 'month=12&year=2020&region=0&state_code=0&channel_type=0';
    this.apiService
      .getHeaders(this.apiConfig.getDashBoardDetails+url)
      .subscribe((res: any) => {
        this.dashboard_details = res.body.data;
        console.log(this.dashboard_details)
      });
  }

}
